import { Inverter } from '../../telemetry';
import { handleInverterPowerValues } from '../../utils';
import { PowerSeries } from '../model';
import { applyColors } from '../styles.utils';

export class GraphPowerHelper {
  data?: PowerSeries;
  maxValue = Number.NEGATIVE_INFINITY;

  readonly handleInverterPowerValues = handleInverterPowerValues;

  constructor(readonly series: Partial<Inverter>[], day: Date, tz: string) {
    day.setHours(12 - day.getTimezoneOffset() / 60 - Number(tz) / 4);
    const midDay = day.getTime();

    this.data = series.reduce((prev: PowerSeries, currentState) => {
      const keys = Object.keys(currentState) as Array<keyof Inverter>;
      keys.filter((key) => ['TS', '__typename'].includes(key) === false).forEach((key) => {
        const value = handleInverterPowerValues(Number(currentState[key]), key);
        const currentTs = Number(currentState.TS) * 1000;
        const positionValue = Math.floor((currentTs - midDay) / 1000);
        this.updateMaxValue(value);
        if (prev[key]) {
          prev[key].values.push([positionValue, value]);
        } else {
          prev[key] = { name: key, values: [[positionValue, value]] };
        }
      });
      return prev;
    }, {});
    Object.keys(this.data).forEach((key) => {
      if (this.data && this.data[key].values) {
        this.data[key].values.sort((a, b) => a[0] <= b[0] ? -1 : 1);
      }
    });
  }

  updateMaxValue(value: number) {
    this.maxValue = this.maxValue < Math.abs(value) ? Math.abs(value) : this.maxValue;
  }

  getSeries() {
    if (!this.data) {
      throw new Error('Missing telemetry');
    }
    this.applyColors();
    return Object.values(this.data);
  }

  applyColors() {
    this.data = applyColors(this.data);
  }

  getGraphOptions(appBuildPowerDailyGraph: any, buildPowerAutomationGraph: any, appBuildStateOfChargeGraph: any, tz: string, minTh?: number, maxTh?: number) {
    const series = this.getSeries();
    const dailyPowerSeries = series.filter((s) => s.name !== 'BP');
    const socSeries = series.filter((s) => s.name === 'BP').pop();
    return {
      automation: buildPowerAutomationGraph(series, this.maxValue, tz, minTh, maxTh),
      dailyPowerState: appBuildPowerDailyGraph(dailyPowerSeries, this.maxValue, tz),
      dailySocState: socSeries && appBuildStateOfChargeGraph(socSeries, tz),
    };
  }
}
